"use client";

import {
	createContext,
	useCallback,
	useContext,
	useMemo,
	useState,
	type ReactNode,
} from "react";

export type ImageryRequestsHeaderSlot = {
	email: string;
	onDifferentEmail: () => void;
	onNewRequest: () => void;
} | null;

type ImageryRequestsHeaderContextValue = {
	slot: ImageryRequestsHeaderSlot;
	setImageryRequestsHeaderSlot: (v: ImageryRequestsHeaderSlot) => void;
};

const ImageryRequestsHeaderContext =
	createContext<ImageryRequestsHeaderContextValue | null>(null);

export function ImageryRequestsHeaderProvider({
	children,
}: {
	children: ReactNode;
}) {
	const [slot, setSlot] = useState<ImageryRequestsHeaderSlot>(null);
	const setImageryRequestsHeaderSlot = useCallback(
		(v: ImageryRequestsHeaderSlot) => {
			setSlot(v);
		},
		[]
	);
	const value = useMemo(
		() => ({ slot, setImageryRequestsHeaderSlot }),
		[slot, setImageryRequestsHeaderSlot]
	);
	return (
		<ImageryRequestsHeaderContext.Provider value={value}>
			{children}
		</ImageryRequestsHeaderContext.Provider>
	);
}

export function useImageryRequestsHeaderSlot(): ImageryRequestsHeaderContextValue {
	const ctx = useContext(ImageryRequestsHeaderContext);
	if (!ctx) {
		throw new Error(
			"useImageryRequestsHeaderSlot must be used within ImageryRequestsHeaderProvider"
		);
	}
	return ctx;
}
